/* eslint-disable no-unused-vars */

import { Tag, UploadItems } from 'store/types';
import reduce from 'lodash-es/reduce';
import omit from 'lodash-es/omit';
import isEmpty from 'lodash-es/isEmpty';
import some from 'lodash-es/some';
import { useFileList } from './useFileList';

export const useTaggedFileList = () => {
  const { _setList, list, ...other } = useFileList();

  const addTag = (tag: Tag, ids: string[]) => {
    _setList((old) => {
      const updated = reduce(
        ids,
        (acc: UploadItems, id) => {
          const copy = { ...old[id] };
          copy.tags[tag.name] = tag;

          acc[copy.id] = copy;

          return acc;
        },
        {}
      );

      return { ...old, ...updated };
    });
  };

  const removeTag = (tag: Tag, ids: string[]) => {
    _setList((old) => {
      const updated = reduce(
        ids,
        (acc: UploadItems, id) => {
          let copy = { ...old[id] };
          copy.tags = omit(copy.tags, tag.name);
          acc[copy.id] = copy;

          return acc;
        },
        {}
      );

      return { ...old, ...updated };
    });
  };

  const validate = () => {
    if (isEmpty(list)) {
      return 'empty';
    }

    const emptyTag = some(list, (item) => isEmpty(item.tags));

    if (emptyTag) {
      return 'empty_tag';
    }

    return 'success';
  };

  return {
    ...other,
    list,
    addTag,
    removeTag,
    validate,
    _setList,
  };
};
